<template>
  <nav class="flex flex-1 flex-col px-4">
    <ul role="list" class="flex flex-1 flex-col gap-y-7">
      <li>
        <NavItems :items="navigation" :icons-only="iconsOnly" />
      </li>

      <li class="mt-auto">
        <NavItems :items="secondaryNavigation" :icons-only="iconsOnly" />
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
import NavItems from '@/components/NavItems.vue'
import { NavItemType } from '@/components/NavItem.vue'

const props = defineProps({
  context: {
    type: String,
    default: 'admin'
  },
  iconsOnly: {
    type: Boolean,
    default: false
  },
  customerId: {
    type: String,
    default: ''
  }
})

const adminNavItems: NavItemType[] = [
  { name: 'Dashboard', label: 'Dashboard', href: '/', iconClass: 'i-heroicons-home' },
  { name: 'ListProjects', label: 'Projects', href: '/projects', iconClass: 'i-heroicons-rectangle-stack' },
  { name: 'ListProposals', label: 'Proposals', href: '/proposals', iconClass: 'i-heroicons-clipboard-document-list' },
  { name: 'ListCustomers', label: 'Customers', href: '/customers', iconClass: 'i-heroicons-users' },
  { name: 'ListInvoices', label: 'Invoices', href: '/invoices',  iconClass: 'i-heroicons-currency-dollar' },
  { name: 'ListSubcontractors', label: 'Subs', href: '/subs',  iconClass: 'i-mdi-construction-outline'},
  {
    name: '',
    label: 'Catalog',
    href: '#',
    iconClass: 'i-heroicons-cube',
    children: [
      { name: 'ListLabor', label: 'Labor', href: '/catalog/labor' },
      { name: 'ListMaterials', label: 'Materials', href: '/catalog/materials' },
      // { name: 'ListServices', label: 'Services', href: '/catalog/services' },
      { name: 'ListBudgetTemplates', label: 'Budget Templates', href: '/catalog/budget-templates' },
      { name: 'ListVendors', label: 'Vendors', href: '/vendors' },
    ]
  },
  {
    name: '',
    label: 'Account Payable',
    href: '#',
    iconClass: 'i-heroicons-banknotes',
    children: [
      { name: 'ListBills', label: 'Bills', href: '/bills'},
      { name: 'ListPurchaseOrders', label: 'Purchase Orders', href: '/purchaseOrders' },
      { name: 'ListWorkOrders', label: 'Work Orders', href: '/workOrders' },
    ]
   },
]
const customerNavItems: NavItemType[] = [
  { name: 'Dashboard', label: 'Dashboard', href: '/', iconClass: 'i-heroicons-home' },
  { name: 'ListCustomerProjects', label: 'My Projects', href: '/projects', iconClass: 'i-heroicons-rectangle-stack', params: { customerId: props.customerId } },
  { name: 'ListCustomerInvoices', label: 'Invoices', href: '/invoices', iconClass: 'i-heroicons-currency-dollar', params: { customerId: props.customerId } },
]

const navigation: NavItemType[] = props.context === 'admin' ? adminNavItems : customerNavItems
const secondaryNavigation: NavItemType[] = [
  { name: 'GeneralSettings', label: 'Settings', href: '/settings/general', iconClass: 'i-heroicons-cog-6-tooth' },
]
</script>
